export function buildOwnerServiceWhatsAppUrl(phone: string, message: string): string {
  const normalizedPhone = phone.replace(/\D/g, "");

  if (!normalizedPhone) {
    return "https://wa.me/";
  }

  return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(message)}`;
}
